export const state = () => ({
	items: [],
	item: {},
	type: null,
	index: null,
	isFetching: false, // Flag to prevent duplicate fetch requests during data loading
});

// Disable strict mode for this module to avoid warnings
export const strict = false;

export const mutations = {
	setItems(state, payload) {
		// Simple assignment - let Vuex handle the reactivity
		state.items = payload || [];
	},
	addObject(state, payload) {
		state.items.push(payload);
	},
	editObject(state, payload) {
		Object.assign(state.items[payload[1]], payload[0]);
		state.index = payload[1];
	},
	deleteObject(state, index) {
		state.items.splice(index, 1);
	},
	addItem(state, payload) {
		state.item = payload;
	},
	setAction(state, payload) {
		state.type = payload;
	},
	emptyItem(state) {
		state.item = [];
		state.type = null;
	},
	setIndex(state, payload) {
		state.index = payload;
	},
	setFetching(state, payload) {
		state.isFetching = payload;
	},
};

export const getters = {
	getItems: (state) => {
		return state.items;
	},
	getItem: (state) => {
		return state.item;
	},
	getType: (state) => {
		return state.type;
	},
	getIndex(state) {
		return state.index;
	},
	isFetching: (state) => state.isFetching,
};
